import { qs } from '../core/utils';

const closeModal = (modal: HTMLElement): void => {
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  const iframe = modal.querySelector('iframe');
  if (iframe) {
    iframe.src = '';
  }
  document.body.style.overflow = '';
};

const openModal = (modal: HTMLElement): void => {
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
};

export const initModals = (): void => {
  const modals = document.querySelectorAll<HTMLElement>('.modal');

  modals.forEach((modal) => {
    const closeButtons = modal.querySelectorAll('[data-modal-close]');
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeModal(modal));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      modals.forEach((modal) => {
        if (modal.classList.contains('is-open')) {
          closeModal(modal);
        }
      });
    }
  });

  const qrTrigger = qs('#qr-trigger');
  const qrModal = qs('#qr-modal');
  qrTrigger?.addEventListener('click', () => {
    if (qrModal) openModal(qrModal);
  });
};

export const openProjectModal = (content: string): void => {
  const modal = qs('#project-modal');
  const body = qs('#project-modal-body');
  if (!modal || !body) return;
  body.innerHTML = content;
  openModal(modal);
};

export const openVideoModal = (url: string): void => {
  const modal = qs('#video-modal');
  const body = qs('#video-modal-body');
  if (!modal || !body) return;
  body.innerHTML = `<iframe width="100%" height="400" src="${url}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
  openModal(modal);
};
